module.exports = __webpack_public_path__ + "static/media/m_1.8adb0497.jpg";